/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {ColorPickerControlComponent as ɵa} from './components/color-picker-control/color-picker-control.component';